var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CountTo',{attrs:{"start-val":_vm.startVal,"end-val":Number(_vm.endVal),"decimals":_vm.isInt(_vm.endVal),"separator":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }